import React, { useCallback, useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import Checklist from "../../components/closeout/Checklist";
import CloseControls from "../../components/closeout/CloseControls";
import { Package, Warranties } from "../../components/closeout/Register";

const TABS = [["checklist", "Checklist"], ["warranties", "Warranties"], ["package", "Turnover package"]];

// B13 project closeout tab (mobile-first: single column under 640px, 44px targets).
export default function ProjectCloseout() {
  const { pid } = useParams();
  const { user } = useAuth();
  const [sp, setSp] = useSearchParams();
  const tab = TABS.some(([k]) => k === sp.get("tab")) ? sp.get("tab") : "checklist";
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");
  const load = useCallback(() => api.get(`/closeout/projects/${pid}`).then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail?.message || "Could not load closeout.")), [pid]);
  useEffect(() => { load(); }, [load]);
  const canManage = ["OWNER_SUPER_ADMIN", "ADMINISTRATOR", "PROJECT_MANAGER"].includes(user?.role_key);
  return (
    <AppShell title="Closeout" subtitle="Checklist, warranties and turnover">
      <div className="mx-auto w-full max-w-[900px] px-3 sm:px-4 space-y-4" data-testid="co-page">
        <div role="tablist" aria-label="Closeout sections" className="flex gap-2 overflow-x-auto">
          {TABS.map(([k, l]) => (
            <button key={k} type="button" role="tab" aria-selected={tab === k} onClick={() => setSp({ tab: k })} data-testid={`co-tab-${k}`}
              className={`min-h-[44px] shrink-0 px-3 rounded border text-sm focus-visible:outline focus-visible:outline-2 ${tab === k ? "bg-erf-navy text-white border-erf-navy" : "bg-white border-erf-borderCream"}`}>{l}</button>))}
        </div>
        {err && <p role="alert" className="text-sm text-red-800" data-testid="co-load-error">{err}</p>}
        {data && tab === "checklist" && <><Checklist data={data} pid={pid} canManage={canManage} reload={load} /><CloseControls data={data} pid={pid} reload={load} /></>}
        {tab === "warranties" && <Warranties pid={pid} canManage={canManage} />}
        {tab === "package" && <Package pid={pid} canManage={canManage} />}
      </div>
    </AppShell>
  );
}
